module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1049-7b96c49728d03869699db2a0d259352e.png";